import SoldsDataTable from '../dashboard/ADMIN/components/SoldsDataTable'

const ItemPopupTable = ({ subjectId }) => {
  return <SoldsDataTable SubjectId={subjectId} />
}

export default ItemPopupTable
